import React, { Component } from 'react'
import Store from 'store'
import createjs from 'preload-js'
import './Loader.css'

class Loader extends Component {
  constructor (props) {
    super(props)
    this.state = {
      pct: 0
    }
  }

  preloadAssets () {
    let visualize = Store.get('visualize')

    if (Array.isArray(visualize.layers) && visualize.layers.length) {
      let queue = new createjs.LoadQueue()
      let manifest = []

      visualize.layers.forEach((element) => {
        switch (element.type) {
          case 'img':
            manifest.push({
              id: element.id,
              src: element.asset
            })
            break
          default:
            break
        }
      })

      if (manifest.length > 0) {
        queue.on('complete', () => this.setState({ pct: 100 }))
        queue.on('error', (event) => console.log('Loading Error', event))
        queue.on('progress', (event) => {
          this.setState({
            pct: Math.round(event.loaded * 100)
          })
        })

        queue.loadManifest(manifest)
      } else {
        this.setState({ pct: 100 })
      }
    }
  }

  componentDidMount () {
    this.preloadAssets()
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.manifest !== nextProps.manifest) {
      this.setState({ pct: 0 }, this.preloadAssets)
    }
  }

  render () {
    console.log(this.state)
    const radius = 3.125
    const circumference = 2 * radius * Math.PI

    if (this.state.pct === 100) {
      return null // Bye bye loader !
    }

    return (
      <div className='visualize-loader'>
        <div className='loader-inner'>
          <div className='loader-percent' data-pct={this.state.pct} />
        </div>
        <svg className='loader-inner' width='7.5em' height='7.5em' version='1.1' xmlns='http://www.w3.org/2000/svg'>
          <circle
            className='loader-bar'
            r={radius + 'em'}
            cx='3.75em'
            cy='3.75em'
            strokeDasharray={circumference + 'em'}
            strokeDashoffset={circumference - (circumference * this.state.pct / 100) + 'em'}
          />
        </svg>
      </div>
    )
  }
}

export default Loader



// WEBPACK FOOTER //
// ./src/lib/react-visualize/Core/Loader.js